import { AxiosRequestConfig } from 'axios';
import {
  STATES,
  SESSION_KEY,
  ERROR_ACTION,
} from 'shared/constants/visitorPrioritization';
import { getUserNumber } from 'shared/helpers/utils/user';
import { isLoyalUser } from 'shared/helpers/auth';

export const VP = (
  requestConfig: AxiosRequestConfig,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  store: any
) => {
  if (__SERVER__) {
    return requestConfig;
  }
  const throwVisitorError = () => {
    store.dispatch({
      type: ERROR_ACTION,
      payload: {
        flag: true,
      },
    });
    throw new Error('');
  };

  let vpConfigs = store.getState()?.VP?.configs;

  // Enhanced logging
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('[VP Interceptor]', {
      hasVPConfigs: !!vpConfigs && Object.keys(vpConfigs).length > 0,
      vpConfigKeys: Object.keys(vpConfigs || {}),
      url: requestConfig.url,
    });
  }

  if (!vpConfigs.web_apis) {
    const dataFromSessionStorage = sessionStorage.getItem(SESSION_KEY);
    if (dataFromSessionStorage) {
      vpConfigs = JSON.parse(dataFromSessionStorage);
      // eslint-disable-next-line no-console
      console.log('[VP Interceptor] Loaded from sessionStorage');
    }
  }
  const {
    web_apis: webApi,
    block_percentage: blockPercentage,
    state,
    resestTimeInMinutes: expiryMins,
    ruleID,
    webEnable,
    webWhitelistPrive,
  } = vpConfigs;
  if (state && webEnable) {
    if (webWhitelistPrive && isLoyalUser()) {
      return requestConfig;
    }
    const userNum = getUserNumber(ruleID, expiryMins);
    const assignedUserNumber = parseInt(String(userNum), 10) || 100;

    if (blockPercentage >= assignedUserNumber && webApi) {
      if (state === STATES.BLOCK_ALL) {
        throwVisitorError();
      }
      const blockedAPIArray = webApi;
      const url = requestConfig.url || '';
      blockedAPIArray.forEach((blockedApi: string) => {
        if (url.indexOf(blockedApi) > -1) {
          throwVisitorError();
          return;
        }
      });
    }
  }
  return requestConfig;
};
